/* Formulaires Contact et devis Professionnels : messages d'erreur dans la page
   et bouton désactivé pendant l'envoi. Sans JavaScript, la validation native
   du navigateur reste en place (le novalidate n'est posé que par ce script). */
(function () {
  var MSG_EMAIL = 'Cette adresse e-mail semble incomplète. Exemple : prenom.nom@exemple.fr';

  function fieldOf(el) { return el.closest('.eck-field'); }

  function setError(el, text) {
    var box = fieldOf(el);
    var err = document.getElementById(el.getAttribute('aria-describedby') || '');
    if (!box || !err) return;
    box.classList.toggle('has-error', !!text);
    err.textContent = text || '';
    if (text) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
  }

  function check(el) {
    if (!el.hasAttribute('required') && el.type !== 'email') return true;
    var v = el.validity;
    if (v.valid) { setError(el, ''); return true; }
    var text = el.getAttribute('data-ec-err') || 'Merci de renseigner ce champ.';
    if (el.type === 'email' && v.typeMismatch) text = MSG_EMAIL;
    setError(el, text);
    return false;
  }

  function init(form) {
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    var fields = [].slice.call(form.querySelectorAll('input[required], textarea[required], select[required], input[type="email"]'));
    form.noValidate = true;

    function release() {
      if (!btn) return;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = label;
    }

    fields.forEach(function (el) {
      el.addEventListener('blur', function () { if (el.value !== '') check(el); });
      el.addEventListener('input', function () { if (fieldOf(el).classList.contains('has-error')) check(el); });
      el.addEventListener('change', function () { if (fieldOf(el).classList.contains('has-error')) check(el); });
    });

    form.addEventListener('submit', function (e) {
      var first = null;
      fields.forEach(function (el) { if (!check(el) && !first) first = el; });
      if (first) {
        e.preventDefault();
        first.focus();
        return;
      }
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Envoi en cours…';
        // Envoi interrompu (retour arrière, contrôle hCaptcha qui n'aboutit pas) : on rend le bouton.
        setTimeout(release, 15000);
      }
    });

    window.addEventListener('pageshow', release);
    document.addEventListener('visibilitychange', function () { if (!document.hidden && btn && btn.disabled) setTimeout(release, 1500); });
  }

  ['ec-contact-form', 'ec-devis-pro'].forEach(function (id) {
    var f = document.getElementById(id);
    if (f) init(f);
  });
})();
